export default __webpack_public_path__ + "static/media/logout_white.978b8784.svg";